import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

const SuburbCard = ({ suburb, agent_slug }) => {
    if (!suburb) return null;
    const href = agent_slug === "home-price"
        ? `/suburb-profile/${suburb.suburb_id}`
        : `/suburb-profile/${suburb.suburb_id}?agent=${encodeURIComponent(agent_slug)}`;

    // Sold Price
    const hasSoldPrice = typeof suburb.median_sold_price_filled === 'number' && suburb.median_sold_price_filled !== null;
    const hasPriorSoldPrice = typeof suburb.prior_median_sold_price === 'number' && suburb.prior_median_sold_price !== null;
    const median_sold_price_display = hasSoldPrice
        ? `$${suburb.median_sold_price_filled.toLocaleString('en-US')}`
        : 'N/A';
    const sold_price_delta = (hasSoldPrice && hasPriorSoldPrice && suburb.prior_median_sold_price !== 0)
        ? (((suburb.median_sold_price_filled - suburb.prior_median_sold_price) / suburb.prior_median_sold_price) * 100).toFixed(0)
        : null;

    // Rent Price
    const hasRentPrice = typeof suburb.median_rent_price_filled === 'number' && suburb.median_rent_price_filled !== null;
    const hasPriorRentPrice = typeof suburb.prior_median_rent_price === 'number' && suburb.prior_median_rent_price !== null;
    const median_rent_price_display = hasRentPrice
        ? `$${suburb.median_rent_price_filled.toLocaleString('en-US')}`
        : 'N/A';
    const rent_price_delta = (hasRentPrice && hasPriorRentPrice && suburb.prior_median_rent_price !== 0)
        ? (((suburb.median_rent_price_filled - suburb.prior_median_rent_price) / suburb.prior_median_rent_price) * 100).toFixed(0)
        : null;

    return (
      <a
        href={href}
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'block'
        }}
      >
        <div style={{
          border: '1px solid #eee',
          borderRadius: 12,
          padding: 16,
          margin: 8,
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between'
        }}>
          <h4 style={{ marginBottom: 16 }}>
            {suburb.suburb_initcap}
          </h4>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            marginBottom: 16,
            textAlign: 'center'
          }}>
            {/* Sold Price */}
            <div style={{ flex: 1 }}>
              <span style={{ fontSize: '0.95em', color: '#555' }}>Median Sold Price</span>
              <h5 style={{ margin: '8px 0' }}>{median_sold_price_display}</h5>
              <div style={{ color: suburb.median_sold_price_percent_change_text === '0%' ? 'gray' : sold_price_delta > 0 ? 'green' : 'red' }}>
                <strong>
                  {suburb.median_sold_price_percent_change_text ?? 'N/A'}
                </strong>
              </div>
            </div>
            {/* Rent Price */}
            <div style={{ flex: 1 }}>
              <span style={{ fontSize: '0.95em', color: '#555' }}>Median Rent Price</span>
              <h5 style={{ margin: '8px 0' }}>{median_rent_price_display}</h5>
              <div style={{ color: suburb.median_rent_price_percent_change_text === '0%' ? 'gray' : rent_price_delta > 0 ? 'green' : 'red' }}>
                <strong>
                  {suburb.median_rent_price_percent_change_text ?? 'N/A'}
                </strong>
              </div>
            </div>
          </div>
          {/* Button is now full width of the card */}
          <button
            type="button"
            style={{
              width: '100%',
              border: '1px solid #333',
              background: 'none',
              color: '#333',
              padding: '6px 0',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: '1em',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              marginTop: 'auto'
            }}
            tabIndex={-1}
          >
            View Profile <FaArrowRight />
          </button>
        </div>
      </a>
    );
};

export default SuburbCard;